<template>
  <div>
    <nv-toasts />
    <portal-target name="dialogs" />
    <Header
      v-if="displayHeader"
      :product-name="productName"
      :menu-items="menuItems"
      :section-menu-items="sectionMenuItems"
      :sub-menu-itens="subMenuItems"
      :display-menu="displayMenu"
      :white-logo="whiteLogo"
    >
      <slot name="header" />
    </Header>
    <main>
      <!-- Page content -->
      <slot />
    </main>
    <Footer v-if="displayFooter"/>
  </div>
</template>
<script lang="ts" setup>
import type { PropType } from 'vue';

// -------------------------------------------
// Hooks
// -------------------------------------------

defineProps({
  displayFooter: { default: true, required: false, type: Boolean },
  displayHeader: { default: true, required: false, type: Boolean },
  whiteLogo: { default: false, required: false, type: Boolean },
  displayMenu: { default: true, required: false, type: Boolean },
  productName: { default: undefined, required: false, type: String },
  menuItems: { default: undefined, type: Array, required: false },
  sectionMenuItems: { default: undefined, type: Array, required: false },
  subMenuItems: { default: () => [], type: Array as PropType<IRoutesLinksResponse[]>, required: false },
});
</script>

<style lang="scss">
/*
* Mixes
*/
@import '@nuiverse/core/src/style/_utils';
@import '@nuiverse/core/src/style/mixins/_breakpoints';

main {
  position: relative;
  z-index: 2;
  min-height: calc(100vh - 522px);
}

</style>
